import { useState } from 'react';
import UtilityStrokeQuestionMarkSmallIcon from '@mweb/zappos-ui/Icons/UtilityStrokeQuestionMarkSmallIcon';
import { Popover, PopoverContent, PopoverPortal, PopoverTrigger } from '@mweb/zappos-ui/Popover';

import InfoOutlineSmallIcon from 'components/common/IconsV2/InfoOutlineSmallIcon';
import { cn } from 'helpers/classnames';

interface TechSpecsTooltipProps {
  children: React.ReactNode;
  contentClasses?: string;
  isMobile?: boolean;
  testId: string;
  text: string;
}

export const TechSpecsTooltip = ({ children, contentClasses, isMobile, testId, text }: TechSpecsTooltipProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Popover open={isTooltipOpen}>
      <PopoverTrigger onMouseEnter={() => setIsTooltipOpen(true)} onMouseLeave={() => setIsTooltipOpen(false)}>
        <div className={cn('flex items-center gap-x-1', { 'text-sm': isMobile })} data-test-id={testId}>
          <span className="text-left text-xs">{text}</span>
          <UtilityStrokeQuestionMarkSmallIcon className="h-3 w-3 lumon:hidden" size={16} />
          <InfoOutlineSmallIcon className="size-3 not-lumon:hidden" size={16} />
        </div>
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          className={cn('inline-block w-48 border-subtle bg-default-minimal text-center text-xs shadow-lg drop-shadow-lg sm:p-1', contentClasses)}
          onOpenAutoFocus={e => e.preventDefault()}
          onCloseAutoFocus={e => e.preventDefault()}
        >
          {children}
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
};
